exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ol-attribution{bottom:10px;right:78px;padding:0}.export-tools button,.ol-attribution button{margin:0;border:1px solid #000;border-radius:4px;box-shadow:3px 3px 3px rgba(0,0,0,.39)}.ol-attribution span{top:1px!important}.ol-attribution ul{font-size:.69em}.ol-zoom{top:auto;left:auto;bottom:10px;right:20px;padding:0}.ol-zoom button{margin:0;display:inline;border:1px solid #000;border-radius:4px;box-shadow:3px 3px 3px rgba(0,0,0,.39)}.ol-zoom-in{border-radius:2px 0 0 2px!important}.ol-zoom-out{border-radius:0 2px 2px 0!important}.record-details-map .ol-viewport{border-radius:8px}.export-tools{position:absolute;bottom:10px;right:126px;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/MapView.css
// module id = 1992
// module chunks = 0